import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { 
            Grid, 
            Button, 
            MenuItem, 
            Select, 
            FormControl, 
            InputLabel, 
            TextField,
            InputAdornment,
            IconButton
        } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';


const useStyles = makeStyles(theme => ({
    textField: {
        width: '100%',
    },
    margin: {
        margin: theme.spacing(1),
    },
    buttonBack: {
        fontSize: '0.6rem',
        color: '#1a1919',
        borderRadius: '0px',
        borderLeft: '3px solid rgba(255, 198, 0)',
        backgroundColor: "white",
        fontFamily: 'Ubuntu',
        fontWeight: 'bold'
    },
    questionSelected : {
        color : '#547710',
        fontWeight: 'bold'
    },
    questionNotSelected : {
        color : 'black'
    }
}));

const FormQuestions = props => {

    const classes = useStyles();

    const { 
            handleNext, 
            handleBack, 
            question, 
            answer, 
            dataquestions, 
            handleChangeQuestion,
            handleChangeAnswer, 
            activeStep,
            formErrors,
            type,
            setType 
        } = props;
    
    const isValid = answer.length > 0 && !formErrors.answer && question > 0

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleChangeTypeText = () => {
        (type === 'text') ? setType('password') : setType('text')
    }

    return (
        
            <Grid container spacing={3}>
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <FormControl variant="outlined" style = {{width: '100%',}}>
                        <InputLabel id="demo-simple-select-outlined-label">Seleccione una pregunta</InputLabel>
                        <Select
                        label="Seleccione una pregunta"
                        labelId="demo-simple-select-label"
                        id="question"
                        fullWidth
                        value = { question}
                        onChange={(e) => handleChangeQuestion(e.target.value) }
                        >
                            <MenuItem key={0} value={0}>Seleccione</MenuItem>
                            {
                                (dataquestions.length > 0) && 
                                    dataquestions.map(option => {
                                        return <MenuItem key={option.id} value={option.id} className = {(option.state === 0) ? classes.questionSelected : classes.questionNotSelected}>{`${option.question}`}</MenuItem>
                                })
                                
                                //})
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={12} lg={12} xl={12}>
                <TextField
                    fullWidth
                    label="Respuesta"
                    name="answer"
                    placeholder="Respuesta"
                    margin="normal"
                    type = {type}
                    autoComplete="off"
                    value={answer || ""}
                    onChange={(e) => handleChangeAnswer(e.target.value)}
                    required
                    inputProps = { {style: { 'textTransform': 'uppercase'}} }
                    error={!!formErrors.answer}
                    helperText={formErrors.answer}
                    InputProps = {{
                        endAdornment:
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleChangeTypeText}
                                    onMouseDown={handleMouseDownPassword}
                                >
                                    {type === 'text' ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            </InputAdornment>
                        
                    }}
                />
                    {/* 
                        <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={ (type === 'text') ? setType('password') : setType('text')}
                                    onMouseDown={handleMouseDownPassword}
                                >
                                    {type === 'text' ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                        <Field
                        name="answer"
                        id="answer"
                        value = {answer}
                        onChange = {(e) => handleChangeAnswer(e.target.value)}
                        autoFocus = { true }
                        component={ RenderTextFieldRedux }
                        label="Respuesta"
                        fullWidth
                    /> */}
                </Grid>
                <Grid item xs={6} md={6}>
                    {
                        (activeStep > 0) &&
                        <Button 
                            fullWidth
                            variant="contained" 
                            className={classes.buttonBack}
                            onClick = { handleBack }
                        >
                            Atras
                        </Button>   
                    }
                </Grid>
                <Grid item xs={6} md={6}>
                    <Button 
                        variant="contained"
                        fullWidth
                        onClick = { handleNext }
                        className={classes.buttonBack}
                        disabled={ !isValid }
                    >
                        { (activeStep === 2) ? "Guardar" : "Siguiente" }
                    </Button>
                </Grid>
            </Grid>
    
    )
    
}

export default FormQuestions
